// Performs given operation in next cycle of JS engine's event loop.
export const performInNextCycle = callback => setTimeout(callback, 0);
